export default __webpack_public_path__ + "static/media/delete.69da3864.svg";